/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-stock.reducer';

export const PharmacyStock = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyStockList = useAppSelector(state => state.pharmacyStock.entities);
  const loading = useAppSelector(state => state.pharmacyStock.loading);
  const totalItems = useAppSelector(state => state.pharmacyStock.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-stock-heading" data-cy="PharmacyStockHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyStock.home.title">Pharmacy Stocks</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pharmacy-stock/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyStock.home.createLabel">Create new Pharmacy Stock</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyStock.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyStockList && pharmacyStockList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('brandId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.brandId">Brand Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('brandId')} />
                </th>
                <th className="hand" onClick={sort('stockQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.stockQty">Stock Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('stockQty')} />
                </th>
                <th className="hand" onClick={sort('manufacDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.manufacDate">Manufac Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('manufacDate')} />
                </th>
                <th className="hand" onClick={sort('expDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.expDate">Exp Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expDate')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('batchNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.batchNumber">Batch Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('batchNumber')} />
                </th>
                <th className="hand" onClick={sort('taxCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.taxCode">Tax Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxCode')} />
                </th>
                <th className="hand" onClick={sort('mrp')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.mrp">Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mrp')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('remainingQuantity')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.remainingQuantity">Remaining Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remainingQuantity')} />
                </th>
                <th className="hand" onClick={sort('packs')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.packs">Packs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('packs')} />
                </th>
                <th className="hand" onClick={sort('HSNCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.HSNCode">HSN Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('HSNCode')} />
                </th>
                <th className="hand" onClick={sort('rack')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.rack">Rack</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rack')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('available')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.available">Available</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('available')} />
                </th>
                <th className="hand" onClick={sort('internal')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.internal">Internal</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('internal')} />
                </th>
                <th className="hand" onClick={sort('shipmentItemId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.shipmentItemId">Shipment Item Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('shipmentItemId')} />
                </th>
                <th className="hand" onClick={sort('addedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.addedById">Added By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedById')} />
                </th>
                <th className="hand" onClick={sort('modifiedById')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.modifiedById">Modified By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedById')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('margin')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.margin">Margin</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('margin')} />
                </th>
                <th className="hand" onClick={sort('cessAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.cessAmount">Cess Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cessAmount')} />
                </th>
                <th className="hand" onClick={sort('exempted')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.exempted">Exempted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exempted')} />
                </th>
                <th className="hand" onClick={sort('importDuty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.importDuty">Import Duty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('importDuty')} />
                </th>
                <th className="hand" onClick={sort('freeQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.freeQty">Free Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('freeQty')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.pharmacy">Pharmacy</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.drug">Drug</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.supplier">Supplier</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.stockBill">Stock Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyStock.uqcType">Uqc Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyStockList.map((pharmacyStock, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-stock/${pharmacyStock.id}`} color="link" size="sm">
                      {pharmacyStock.id}
                    </Button>
                  </td>
                  <td>{pharmacyStock.brandId}</td>
                  <td>{pharmacyStock.stockQty}</td>
                  <td>{pharmacyStock.manufacDate}</td>
                  <td>{pharmacyStock.expDate}</td>
                  <td>{pharmacyStock.timestampentry}</td>
                  <td>{pharmacyStock.microSec}</td>
                  <td>{pharmacyStock.lastupdated}</td>
                  <td>{pharmacyStock.active ? 'true' : 'false'}</td>
                  <td>{pharmacyStock.cursor}</td>
                  <td>{pharmacyStock.batchNumber}</td>
                  <td>{pharmacyStock.taxCode}</td>
                  <td>{pharmacyStock.mrp}</td>
                  <td>{pharmacyStock.price}</td>
                  <td>{pharmacyStock.remainingQuantity}</td>
                  <td>{pharmacyStock.packs}</td>
                  <td>{pharmacyStock.HSNCode}</td>
                  <td>{pharmacyStock.rack}</td>
                  <td>{pharmacyStock.discount}</td>
                  <td>{pharmacyStock.available ? 'true' : 'false'}</td>
                  <td>{pharmacyStock.internal ? 'true' : 'false'}</td>
                  <td>{pharmacyStock.shipmentItemId}</td>
                  <td>{pharmacyStock.addedById}</td>
                  <td>{pharmacyStock.modifiedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyStock.addedByType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyAddedByType.${pharmacyStock.modifiedByType}`} />
                  </td>
                  <td>{pharmacyStock.margin}</td>
                  <td>{pharmacyStock.cessAmount}</td>
                  <td>{pharmacyStock.exempted ? 'true' : 'false'}</td>
                  <td>{pharmacyStock.importDuty}</td>
                  <td>{pharmacyStock.freeQty}</td>
                  <td>
                    {pharmacyStock.pharmacy ? <Link to={`/pharmacy/${pharmacyStock.pharmacy.id}`}>{pharmacyStock.pharmacy.id}</Link> : ''}
                  </td>
                  <td>{pharmacyStock.drug ? <Link to={`/medicine/${pharmacyStock.drug.id}`}>{pharmacyStock.drug.id}</Link> : ''}</td>
                  <td>
                    {pharmacyStock.supplier ? (
                      <Link to={`/pharmacy-suppliers/${pharmacyStock.supplier.id}`}>{pharmacyStock.supplier.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyStock.stockBill ? (
                      <Link to={`/pharmacy-stock-bill/${pharmacyStock.stockBill.id}`}>{pharmacyStock.stockBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyStock.uqcType ? (
                      <Link to={`/clinical-dictionary/${pharmacyStock.uqcType.id}`}>{pharmacyStock.uqcType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pharmacy-stock/${pharmacyStock.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-stock/${pharmacyStock.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-stock/${pharmacyStock.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyStock.home.notFound">No Pharmacy Stocks found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyStockList && pharmacyStockList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyStock;
